// 社保卡临时挂失——微信，主流程
const wxMainRoutes = Array.from({ length: 18 }, (_, i) => ({
  path: `temporary/wx/index${i + 1}`,
  name: `temporaryWxIndex${i + 1}`,
  component: () => import(`@/views/society/temporary/wx/index${i + 1}.vue`)
}))

// 社保卡临时挂失——支付宝，主流程
const zfbMainRoutes = Array.from({ length: 18 }, (_, i) => ({
  path: `temporary/zfb/index${i + 1}`,
  name: `temporaryZfbIndex${i + 1}`,
  component: () => import(`@/views/society/temporary/zfb/index${i + 1}.vue`)
}))

// 社保卡临时挂失——皖事通，主流程
const wstMainRoutes = Array.from({ length: 18 }, (_, i) => ({
  path: `temporary/wst/index${i + 1}`,
  name: `temporaryWstIndex${i + 1}`,
  component: () => import(`@/views/society/temporary/wst/index${i + 1}.vue`)
}))

export default {
  path: '/society',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 社保卡临时挂失——微信，开始
    ...wxMainRoutes,

    // 社保卡临时挂失——支付宝，主流程
    ...zfbMainRoutes,

    // 社保卡临时挂失--皖事通, 主流程
    ...wstMainRoutes,
  ]
}
